// extracted by mini-css-extract-plugin
export default {"wrapper":"Cs2lJAkr","mobile":"mobile","instagram-media":"instagram-media","leftSnippet":"mi2nCk8M","rightSnippet":"wTWSEItO","divider":"Izdzdglk"};